import type { MumulLiveProfileStatus } from 'shared/src/api';

export type MumulLiveStatusDisplay = {
  ringColor: string;
};

/**
 * 무물라이브 프로필 상태별 마켓홈 프로필 표시 정보.
 * DEFAULT 는 별도 표시가 없으므로 제외한다.
 */
const MUMUL_LIVE_STATUS_DISPLAY: Record<
  Exclude<MumulLiveProfileStatus, 'DEFAULT'>,
  MumulLiveStatusDisplay
> = {
  LIVE: { ringColor: '#EC0000' },
  HAS_UNREAD_STORY: { ringColor: '#7728FF' },
  ALL_READ_STORY: { ringColor: '#CCCCCC' },
};

/**
 * 상태값에 해당하는 표시 정보를 반환한다. DEFAULT 이거나 없으면 null.
 */
export const getMumulLiveStatusDisplay = (
  status: MumulLiveProfileStatus | null | undefined,
): MumulLiveStatusDisplay | null => {
  if (status == null || status === 'DEFAULT') {
    return null;
  }
  return MUMUL_LIVE_STATUS_DISPLAY[status];
};
